<template>
    <v-container fluid>
       <v-row
        align="center"
        justify="center"
        class="mx-0"
      >
        <v-col cols="12">
            <v-hover>
                <template v-slot:default="{ hover }">
                <v-card
                    outlined
                >
                    <v-card-title>
                        Industry Specific Profile
                    </v-card-title>
                    <v-card-text>
                        <v-skeleton-loader
                            v-bind="skeltonLoaderAttrs"
                            type="list-item-avatar-two-line"
                        ></v-skeleton-loader>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <v-skeleton-loader
                                    v-bind="skeltonLoaderAttrs"
                                    type="article"
                                ></v-skeleton-loader>
                            </v-col>
                            <v-col  cols="12" sm="4">
                                <v-skeleton-loader
                                    v-bind="skeltonLoaderAttrs"
                                    type="article"
                                ></v-skeleton-loader>
                            </v-col>
                            <v-col  cols="12" sm="4">
                                <v-skeleton-loader
                                    v-bind="skeltonLoaderAttrs"
                                    type="article"
                                ></v-skeleton-loader>
                            </v-col>
                        </v-row>
                        <v-skeleton-loader
                        class="mt-2"
                            v-bind="skeltonLoaderAttrs"
                            type="card, actions"
                        ></v-skeleton-loader>
                    </v-card-text>
                    <v-fade-transition>
                    <v-overlay
                        absolute
                        opacity="0.75"
                    >
                        <v-btn color="primary" rounded @click="sendRequestDialog = true" ><v-icon class="mr-2">mdi-lock-open</v-icon> Request Access</v-btn>
                    </v-overlay>
                    </v-fade-transition>
                    <SendRequestDialog requestType="INDUSTRY_SPECIFIC_PROFILE" :showDialog="sendRequestDialog" @canceled="sendRequestDialog = false" />
                </v-card>
                </template>
            </v-hover>
        </v-col>
       </v-row>
    </v-container>
</template>
<script>
import SendRequestDialog from '@/components/SendRequestDialog'
export default {
    name: 'IndustrySpecificProfile',
    components: {
        SendRequestDialog,
    },
    data() {
        return {
             skeltonLoaderAttrs: {
                class: 'my-2',
                boilerplate: true,
                elevation: 0,
                absolute: true,
                overlay: true,
            },
            overlay: false,
            sendRequestDialog: false,
        };
    },
}
</script>